import { render, staticRenderFns } from "./productTeaserImage.vue?vue&type=template&id=1447b63d&scoped=true"
import script from "./productTeaserImage.vue?vue&type=script&lang=ts"
export * from "./productTeaserImage.vue?vue&type=script&lang=ts"
import style0 from "./productTeaserImage.vue?vue&type=style&index=0&id=1447b63d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1447b63d",
  null
  
)

export default component.exports